import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { Box, Breadcrumbs, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface PageHeaderProps {
  breadcrumb: Array<{ label: string }>;
  title: string;
  subtitle?: string;
  breadcrumbAriaLabel?: string;
}

export function PageHeader({
  breadcrumb,
  title,
  subtitle,
  breadcrumbAriaLabel,
}: PageHeaderProps) {
  const { t } = useTranslation('entity-portal');
  const resolvedAriaLabel = breadcrumbAriaLabel ?? t('common.pageBreadcrumbAria');
  return (
    <Box sx={{ mb: 3 }}>
      <Breadcrumbs
        separator={<NavigateNextIcon fontSize="small" />}
        aria-label={resolvedAriaLabel}
        sx={{ mb: 1 }}
      >
        {breadcrumb.map((item, index) => (
          <Typography key={`${item.label}-${index}`} variant="caption" color="text.secondary">
            {item.label}
          </Typography>
        ))}
      </Breadcrumbs>

      <Typography
        variant="h2"
        component="h1"
        sx={{
          mb: subtitle ? 0.75 : 0,
          typography: { xs: 'h3', md: 'h2' },
        }}
      >
        {title}
      </Typography>

      {subtitle ? (
        <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 760 }}>
          {subtitle}
        </Typography>
      ) : null}
    </Box>
  );
}
